export default {
  data() {
    return {
      filters: [
        {
          label: '24 Hours',
          since: '23 hours',
          interval: 'hour',
        },
        {
          label: '7 Days',
          since: '6 days',
          interval: 'day',
        },
        {
          label: '31 Days',
          since: '30 days',
          interval: 'day',
        },
      ],
    };
  },
};
